// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__TCZSK","bigColWidth":"Table_bigColWidth__3fQQC","biggerColWidth":"Table_biggerColWidth__399l-","row":"Table_row__3D0_L","col":"Table_col__3M9eB"};